import React, {Component} from "react";
import { connect } from "react-redux";
import * as clientDataCollectActions from "../../clientDataCollect/clientDataCollectActions";

class ToggleComponent extends Component {
    constructor(props) {
        super(props)
        this.reference = React.createRef();
    }

    handleEvent(e) {
        if (e.type === "change" && e.detail) {
          this.props.onValueChanged(
            this.props.attributes.elementId,
            e.detail.checked
          );
        }
    }

    componentDidMount() {
        this.setupInputs()
    }

    componentWillUnmount() { 
        if(this.reference.current)
          this.reference.current.removeEventListener('change', this)
    }

    setupInputs() 
    {
        this.reference.current.name = this.props.attributes.elementId
        this.reference.current.label = this.props.attributes.label
        this.reference.current.required = this.props.attributes.mandatory   
        this.reference.current.disabled = this.props.attributes.isEditable === false || this.props.attributes.isNativeField === true

        this.reference.current.addEventListener('change', this)
    }

    render() { 
        return (
            <mosaic-toggle ref= {this.reference} 
            checked = {this.props.attributes.value === "true" ? "checked" : null}            
            icon = "checked_2"
            block/>  
        )       
    }
}

const mapDispatchToProps = dispatch => {
    return {
      onValueChanged: (elementId, value) =>
        dispatch(clientDataCollectActions.fieldsValueChanged(elementId, value))
    };
  };

  export default connect(
    null,
    mapDispatchToProps
  )(ToggleComponent);